var render, staticRenderFns
import script from "./GoodsShelves.vue?vue&type=script&lang=js"
export * from "./GoodsShelves.vue?vue&type=script&lang=js"
import style0 from "./GoodsShelves.vue?vue&type=style&index=0&id=4c722e2a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c722e2a",
  null
  
)

export default component.exports